import api from './connectionProxy'

const normalizeConteudosResponse = function (response, fallback) {
  const data = response.data || {}
  const pagination = data.pagination || {}
  const conteudos = data.conteudos || data.items || []
  const fallbackPage = (fallback || {}).page || 0
  const fallbackPerPage = (fallback || {}).perPage || 20

  return {
    items: conteudos,
    length: pagination.total || data.total || conteudos.length,
    page: typeof pagination.page === 'number' ? pagination.page - 1 : fallbackPage,
    rowsPerPage: pagination.limit || fallbackPerPage,
  }
}

/**
 * GET /api/v1/conteudos - Lista conteúdos com paginação e filtros
 */
export const getConteudos = function (params) {
  params = params || {}
  const page = params.page || 0
  const perPage = params.perPage || 20
  const order = params.order || {}
  const tipo = params.tipo || ''
  const titulo = params.titulo || ''

  const apiParams = {
    page: page + 1,
    limit: perPage,
    order_by: 'criado_em',
    order: order.direction === -1 ? 'asc' : 'desc',
  }

  if (tipo) apiParams.tipo = tipo
  if (titulo) apiParams.search = titulo

  return api.vectorization
    .get('/api/v1/conteudos', { params: apiParams })
    .then(function (response) {
      const normalized = normalizeConteudosResponse(response, { page, perPage })
      return {
        data: {
          items: normalized.items,
          length: normalized.length,
          page: normalized.page,
          rowsPerPage: normalized.rowsPerPage,
          order,
        },
      }
    })
}

/**
 * GET /api/v1/conteudos/:content_id/status
 */
export const getConteudoStatus = function (contentId) {
  return api.vectorization.get('/api/v1/conteudos/' + contentId + '/status')
}

/**
 * GET /api/v1/conteudos/historico
 */
export const getConteudosHistorico = function (params) {
  params = params || {}
  return api.vectorization.get('/api/v1/conteudos/historico', {
    params: {
      page: params.page || 1,
      limit: params.limit || 20,
      content_id: params.content_id || undefined,
      tipo: params.tipo || undefined,
      operacao: params.operacao || undefined,
      id_vetor: params.id_vetor || undefined,
    },
  })
}

/**
 * POST /api/v1/conteudos - Ingere novo conteúdo (processamento assíncrono → 202)
 * Campo canônico: conteudoHtml (aliases aceitos pela API: documento, document)
 */
export const addConteudo = function (conteudo) {
  const payload = { ...conteudo }

  return api.vectorization.post('/api/v1/conteudos', payload)
}

/**
 * POST /api/v1/conteudos/:content_id/reprocessamentos
 * Reenvia conteúdo com falha para reprocessamento
 */
export const reprocessarConteudo = function (contentId) {
  return api.vectorization.post('/api/v1/conteudos/' + contentId + '/reprocessamentos')
}

/**
 * DELETE /api/v1/conteudos/:content_id
 * Remove vetores Qdrant + registros do banco em cascata
 */
export const deleteConteudo = function (contentId) {
  return api.vectorization.delete('/api/v1/conteudos/' + contentId)
}

export const addConteudosLote = function (itens) {
  const normalizedItens = (itens || []).map(function (item) {
    const normalized = { ...item }

    if (normalized.conteudoHtml && !normalized.document) {
      normalized.document = normalized.conteudoHtml
      delete normalized.conteudoHtml
    }

    if (normalized.idVetor && !normalized.id_vetor) {
      normalized.id_vetor = normalized.idVetor
      delete normalized.idVetor
    }

    return normalized
  })

  return api.vectorization.post('/api/v1/conteudos/lote', { itens: normalizedItens })
}

export const buscarConteudosDuplicados = function (params) {
  params = params || {}
  return api.vectorization.post('/api/v1/conteudos/duplicados', {
    query: params.query || undefined,
    id_vetor: params.id_vetor || params.idVetor || undefined,
    score_minimo: params.score_minimo || params.scoreMinimo || 0.9,
    isbn: params.isbn || null,
    tipo: params.tipo || undefined,
    especialidade: params.especialidade || undefined,
    top_k: params.top_k || params.topK || 20,
  })
}

export const getDiagnosticLogs = function (lambdaName, params) {
  params = params || {}
  return api.vectorization.get('/api/v1/diagnosticos/logs', {
    params: {
      lambda: lambdaName,
      minutos: params.minutos || 10,
      limite: params.limite || 50,
    },
  })
}

export const normalizeConteudosListPayload = normalizeConteudosResponse



// WEBPACK FOOTER //
// ./src/api/contentVectorization.js